import React, { useRef, useState } from 'react';
import Product from '../../product/Product/Product';
import { navigateV2 } from '../../../common/utils/router';
import T from '../../../common/components/T';
import Pagination from '../../pagination/Pagination/Pagination';
import Plug from '../../plug/Plug/Plug';
import result_is_empty from '../../../public/src/img/plugs/result_is_empty.svg';
import not_found_any_product from '../../../public/src/img/plugs/not_found_any_product.svg';

const StoreProductGrid = ({ compStyles, productData, setProductData, category = {}, selectProduct, isLoadingPrice }) => {
    const wrapper = useRef(null);
    const [isAllowAddProduct, setAllowAddProduct] = useState(true);

    return (
        <div ref={wrapper} className={compStyles.storeProductGrid}>
            {productData?.data?.length > 0 ? (
                productData.data.map((product, idx) => (
                    <Product
                        isLoadingPrice={isLoadingPrice}
                        stylesMix={compStyles}
                        product={product}
                        selectProduct={selectProduct}
                        key={`productGrid${idx}`}
                        isAllowAddProduct={isAllowAddProduct}
                        setAllowAddProduct={setAllowAddProduct}
                    />
                ))
            ) : category?.data && Object.keys(category?.data).length ? (
                <div className={compStyles.categoryNo} style={{ padding: '80px 16px', minHeight: 'auto' }}>
                    <Plug
                        plugImg={result_is_empty}
                        plugTitle={<T textName='storeNoCategory' defaultStr='В данной категории нет товаров' page='/store' />}
                        btnGroups={[
                            [
                                {
                                    text: <T textName='storeBackToGeneral' defaultStr='Вернуться на главную' page='/store' />,
                                    onClick: () => navigateV2('/store')
                                }
                            ]
                        ]}
                    />
                </div>
            ) : (
                <div style={{ padding: '88px 16px', minHeight: 'auto' }} className={compStyles.categoryNo}>
                    <Plug
                        plugDescription={
                            <T
                                textName='storeNoSearchCategory'
                                defaultStr='Измените условия поиска или нажмите на кнопку «Каталог товаров»'
                                page='/store'
                            />
                        }
                        plugImg={not_found_any_product}
                        plugTitle={
                            <T
                                textName='storeNoSearchProduct'
                                defaultStr='По вашему запросу не найдено ни одного товара'
                                page='/store'
                            />
                        }
                    />
                </div>
            )}
            {!!productData.links &&
            !!productData.meta &&
            Object.keys(productData.links).filter((k) => productData.links[k]).length > 2 ? (
                <div className={compStyles.storePagination}>
                    <Pagination links={productData.links} meta={productData.meta} setTableData={setProductData} />
                </div>
            ) : null}
        </div>
    );
};
export default StoreProductGrid;
